import {selectBestVimeoSource, selectBestVimeoPoster, httpsify} from './vimeo_data_util';

/**
 * Map of media sub-types to their related cms field
 */
const mediaFieldTypeMap = { 
  image: 'image',
  video: 'slide_video',
  video_loop: 'slide_video'
}

/**
 * Used to distinguish video, to video_loops
 * 
 * @param  {item} item   slide-item
 * @return {string}      video, video_loop or image
 */
export const getSlideMediaSubtype = (item) => {
  const mediaType = item.get('media')
  if (mediaType === 'image') { return 'image' }
  return item.get('slide_video_inline') ? 'video' : 'video_loop'
}

export const getSlideMedia = (item, contentWidth = 960) => {
  if (!item) { return {} }
  const slideType = getSlideMediaSubtype(item)
  if (slideType === 'image') {
    const size = contentWidth > 960 ? 'xlarge' : 'large'
    const image = {
      type: slideType,
      link: item.getIn(['slide_image', 'sizes', `${size}`]),
      width: item.getIn(['slide_image', 'sizes', `${size}-width`]),
      height: item.getIn(['slide_image', 'sizes', `${size}-height`])
    }
    return { image }
  }
	// pick up either full video or loop object
  const slideRef = mediaFieldTypeMap[slideType]
  let slideVideo = item.get(slideRef)
  slideVideo = slideVideo && slideVideo.toJS()

  if (slideVideo) {
    const video = selectBestVimeoSource(slideVideo, contentWidth)
    const poster = selectBestVimeoPoster(slideVideo, contentWidth)
    
    if (video) video.link = httpsify(video.link)
    if (poster) poster.link = httpsify(poster.link)
    
    return {
      type: slideType,
      video, poster
    }
  }

}


// WEBPACK FOOTER //
// ./src/lib/mediaUtil.js